export type Platform = 'ios' | 'android';
export type PushProvider = 'fcm' | 'apns';

export const PLATFORM_ICONS = {
  ios: 'apple',
  android: 'android',
};

export const PLATFORM_ICONS_CLASSES = {
  ios: 'push-config__icon-ios',
  android: 'push-config__icon-android',
};

export const PLATFORM_LABELS: Record<string, string> = {
  ios: 'iOS',
  android: 'Android',
};

export const CORRESPONDING_DEVICE_OPTIONS: Record<string, string> = {
  ios_banner: 'android_heads_up',
  ios_lock_screen: 'android_lock_screen',
  ios_expanded: 'android_expanded',
  android_heads_up: 'ios_banner',
  android_lock_screen: 'ios_lock_screen',
  android_expanded: 'ios_expanded',
};
